import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "@themes";

export const ContentImg = styled.div`
  width: 226.27px;
  height: 137px;
  margin: 1.8em 0.5em 0em 0.5em;
`;

export const ContentInfo = styled.div``;

export const MySpaceTitle = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  padding: 0.5em 0.5em 0;
  margin-bottom: 0;
  font-size: 16px;
  @media only screen and (max-width: 480px) {
    margin-left: inherit;
  }
`;

export const MySpaceDescription = styled.p`
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  padding: 0 0.5em;
  font-size: 12px;
  margin: 0.2em auto;
  @media only screen and (max-width: 480px) {
    margin-left: inherit;
  }
`;

export const DateDescription = styled.p`
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  padding: 0 0.5em;
  margin: 0.2em auto;
  font-size: 12px;
  @media only screen and (max-width: 480px) {
    margin-left: inherit;
  }
`;

export const ContentDescriptLang = styled.span`
  display: flex;
  align-items: center;
`;

export const ContentTooltip = styled.div`
  padding: 0.5em;
  span {
    font-size: 12px;
    color: #181818;
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ButtonViewPreview = styled.div`
  display: flex;
  justify-content: flex-end;
  justify-self: center;
  align-self: center;
  align-items: center;
  background-color: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  width: 3.4375em;
  height: 1.5625em;
  margin-right: 0.8em;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
    background-color: ${({ theme }) => theme.button.primaryHover};
    color: ${({ theme }) => theme.neutral.white};
  }
`;

export const useStyles = makeStyles(() => ({
  containerSpace:{ 
    boxShadow: "0px 2px 8px rgba(46, 46, 46, 0.1)",
    borderRadius: "5px",
    height: "fit-content",
  },
  imgOtherEvent: {
    width: "100%",
    height: "100%",
  },
}));
